import { Box, Button, Input, makeStyles } from '@material-ui/core';
import React, { FC, useState } from 'react';
import colorRectangle from 'src/images/colorRectangle.png';
import { ChromePicker } from 'react-color';
import { RootState, useDispatch, useSelector } from 'src/store';
import useComponentVisible from 'src/hooks/useComponentVisible';
import { editBtnBgColor } from 'src/store/modules/buttons';

interface editBtnBgColorProps {
  type: string;
}

const useStyles = makeStyles(() => ({
  root: {
    fontFamily: "'Poppins', sans-serif",
    fontSize: '13px'
  },
  container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  colorContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: '8px',
    alignItems: 'center'
  },

  buttonWrapper: {
    maxWidth: '32px',
    minWidth: '32px',
    maxHeight: '32px',
    minHeight: '32px',
    borderRadius: '6px'
  },
  buttonImage: {
    maxWidth: '24px',
    minWidth: '24px',
    maxHeight: '24px',
    minHeight: '24px'
  },

  boxWrapper: {
    margin: '0 8px',
    display: 'flex',
    justifyContent: 'space-between'
  },
  colorBox: {
    padding: '6px 10px',
    borderRadius: '6px',
    backgroundColor: '#F2F3F5',
    textAlign: 'center',
    color: '#191F28',
    fontFamily: "'Poppins', sans-serif",
    fontSize: '12px',
    fontWeight: 400
  },
  opacityBox: {
    width: '48px',
    padding: '6px 10px',
    borderRadius: '6px',
    backgroundColor: '#F2F3F5',
    textAlign: 'center',
    color: '#191F28',
    fontFamily: "'Poppins', sans-serif",
    fontSize: '12px',
    fontWeight: 400
  },

  backgroundColor: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  }
}));

const EditBtnBgColor: FC<editBtnBgColorProps> = ({ type }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const btnBgColorR = useSelector(
    (state: RootState) => state.buttons.btnBgColorR
  );
  const btnBgColorG = useSelector(
    (state: RootState) => state.buttons.btnBgColorG
  );
  const btnBgColorB = useSelector(
    (state: RootState) => state.buttons.btnBgColorB
  );
  const btnBgColorA = useSelector(
    (state: RootState) => state.buttons.btnBgColorA
  );

  const {
    refPicker,
    refButton1,
    refButton2,
    isComponentVisible,
    setIsComponentVisible
  } = useComponentVisible(false);

  const handleColorPicker = () => {
    setIsComponentVisible(!isComponentVisible);
  };

  const handleChangeComplete = c => {
    const newBtnBgColorR = JSON.parse(`{"${type}": ${c.rgb.r}}`);
    const newBtnBgColorG = JSON.parse(`{"${type}": ${c.rgb.g}}`);
    const newBtnBgColorB = JSON.parse(`{"${type}": ${c.rgb.b}}`);
    const newBtnBgColorA = JSON.parse(`{"${type}": ${c.rgb.a}}`);
    dispatch(
      editBtnBgColor(
        { ...btnBgColorR, ...newBtnBgColorR },
        { ...btnBgColorG, ...newBtnBgColorG },
        { ...btnBgColorB, ...newBtnBgColorB },
        { ...btnBgColorA, ...newBtnBgColorA }
      )
    );
  };

  function ColorToHex(color) {
    const hexadecimal = color.toString(16);
    return hexadecimal.length == 1 ? `0${hexadecimal}` : hexadecimal;
  }
  function ConvertRGBtoHex(red, green, blue) {
    return `#${ColorToHex(red)}${ColorToHex(green)}${ColorToHex(blue)}`;
  }

  return (
    <div className={classes.root}>
      <Box className={classes.container}>
        <Box className={classes.colorContainer}>
          <Button
            ref={refButton1}
            onClick={handleColorPicker}
            className={classes.buttonWrapper}
          >
            <img
              alt="color"
              src={colorRectangle}
              className={classes.buttonImage}
            />
          </Button>
          <Button
            ref={refButton2}
            style={{
              maxWidth: '1.25rem',
              minWidth: '1.25rem',
              maxHeight: '1.25rem',
              minHeight: '1.25rem',
              padding: 0
            }}
            onClick={handleColorPicker}
          >
            <div
              style={{
                width: '1.25rem',
                height: '1.25rem',
                backgroundColor: `rgb(${btnBgColorR[type]},${btnBgColorG[type]},${btnBgColorB[type]})`,
                border: '1px solid #E5E8EB',
                borderRadius: 999
              }}
            />
          </Button>
          <div className={classes.colorBox}>
            {ConvertRGBtoHex(
              btnBgColorR[type],
              btnBgColorG[type],
              btnBgColorB[type]
            ).toUpperCase()}
          </div>
          {/* <Input
            disableUnderline
            style={{
              overflow: 'hidden',
              width: 70,
              fontFamily: 'Roboto',
              fontSize: 12
            }}
            onChange={handleChangeColor}
            value={colorPreview}
          /> */}
        </Box>
        <Box className={classes.colorContainer}>
          <div className={classes.opacityBox}>
            {Math.round(btnBgColorA[type] * 100)}%
          </div>
        </Box>
      </Box>
      {isComponentVisible && (
        <div ref={refPicker} style={{ width: '100%', marginTop: '1rem' }}>
          <ChromePicker
            color={`rgba(${btnBgColorR[type]},${btnBgColorG[type]},${btnBgColorB[type]},${btnBgColorA[type]})`}
            onChange={handleChangeComplete}
            width="100%"
          />
        </div>
      )}
    </div>
  );
};

export default EditBtnBgColor;
